import type { InputMappingGroup } from '@/features/InputMapping/types';
import SaisonkennzeichenInfo from '@/components/modals/InputMapping/partials/sectionInfoTypes/SaisonkennzeichenInfo/SaisonkennzeichenInfo.vue';
import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import { getLocaleDateString } from '@/utils/dates/dates';
import { formatNumber } from '@/utils/formatters/number';
import boolean from '@/utils/formatters/boolean';
import {
  isVollkasko,
  visibleGapDeckung,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { computed } from 'vue';
import { INPUT_MAPPING_SOURCE } from '@/features/InputMapping/types';

export const absicherungsGroupMapping: InputMappingGroup = {
  icon: 'car-burst',
  label: 'Gewünschte Absicherung',
  infos: [
    {
      component: SaisonkennzeichenInfo,
      props: {
        startPath: 'saisonkennzeichen.monatsAnfang',
        endPath: 'saisonkennzeichen.monatsEnde',
      },
      noPadding: true,
      requiredPaths: [
        'saisonkennzeichen.monatsAnfang',
        'saisonkennzeichen.monatsEnde',
      ],
    },
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'versicherungsbeginn',
            formatter: getLocaleDateString,
          },
          {
            path: 'deckungssumme',
            formatter: formatChoice(SIMPLE_CHOICE.KFZ_DECKUNGSSUMME),
          },
          {
            path: 'kaskoTyp',
            formatter: formatChoice(SIMPLE_CHOICE.KASKO_TYP),
          },
          {
            path: 'sfKlasseKH',
            formatter: formatChoice(SIMPLE_CHOICE.SF_KLASSE_KH),
            allowedSources: [
              INPUT_MAPPING_SOURCE.GDV,
              INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT,
            ],
          },
          {
            path: 'sfKlasseVK',
            formatter: formatChoice(SIMPLE_CHOICE.SF_KLASSE_VK),
            allowedSources: [
              INPUT_MAPPING_SOURCE.GDV,
              INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT,
            ],
          },
          {
            path: 'kaskoSB.teilkasko',
            suffix: '€',
            formatter: formatNumber,
          },
          {
            path: 'kaskoSB.vollkasko',
            suffix: '€',
            formatter: formatNumber,
          },
          {
            path: 'zahlweise',
            formatter: formatChoice(SIMPLE_CHOICE.PAYMENT_PERIOD),
          },
          {
            path: 'schutzbriefleistungen',
            formatter: boolean,
          },
          {
            path: 'fahrerschutzversicherung',
            formatter: boolean,
          },
          {
            path: 'rabattschutzKfzHaftpflicht',
            formatter: boolean,
            isHidden: computed(() => isVollkasko.value),
          },
          {
            path: 'rabattschutzVollkasko',
            formatter: boolean,
            isHidden: computed(() => !isVollkasko.value),
          },
          {
            path: 'gapDeckung',
            formatter: boolean,
            isHidden: computed(() => !visibleGapDeckung.value),
          },
        ],
      },

      requiredPaths: [
        'zahlweise',
        'deckungssumme',
        'kaskoTyp',
        'versicherungsbeginn',
        'sfKlasseKH',
        'sfKlasseVK',
        'kaskoSB.teilkasko',
        'kaskoSB.vollkasko',
        'schutzbriefleistungen',
        'fahrerschutzversicherung',
        'rabattschutzKfzHaftpflicht',
        'rabattschutzVollkasko',
        'gapDeckung',
      ],
      requiredOr: true,
    },
  ],
};
